import moment from "moment-timezone";

export const formatDeletedAt = (time, locale) =>
  moment
    .tz(time, "America/Sao_Paulo")
    .locale(locale)
    .format("D MMMM YYYY | HH:mm:ss");
